import { React, useState } from 'react';
import PropTypes from 'prop-types';
import { CodeIcon } from "@heroicons/react/solid";

import { projects } from "../../data";

import './Projects.css';

import Modal from "react-modal";

Modal.setAppElement("#root")

const Projects = () => {
  const [isOpen, setIsOpen] = useState(false);
  function toggleModal() {
    setIsOpen(!isOpen);
  }

  const [touchTarget, setTouchTarget] = useState();

  return (

    <section id="projects" className="min-h-screen text-black bg-white body-font justify-center">
       <Modal
          isOpen={isOpen}
          onRequestClose={toggleModal}
          contentLabel="My dialog"
        >
          <div > My modal dialog.</div>
          <button onClick={toggleModal}>Close modal</button>
      </Modal>
  
      <div className="lg:w-1024 sm:w-full mx-auto flex px-8 py-24 flex-col">
        <div className="flex flex-col w-full mb-8">
          {/*<CodeIcon className="mx-auto inline-block w-10 mb-4" />*/}
          <h1 className="w-full text-2xl sm:text-4xl font-medium title-font mb-4 text-black">
            Projects + Explorations
          </h1>
          <p className="w-full text-lg tracking-widest">
            End-User Development, Ubiquitous Computing, Tangible Interaction and eXtended Reality
          </p>
        </div>
        <div className="flex flex-wrap -ml-2 -mr-2 ">
          {projects.map((project, i) => (
  
            <div
              
            onTouchStart={(e) =>{
              console.log(e);
              console.log(e.target.tagName);
            }}

              key={project.image}
              className="sm:w-1/3 p-2 z-1 aspect-square w-full h-full">
              
              <h2 className="tracking-widest text-base font-medium text-green-700">
                {project.subtitle}
              </h2>
              <h1 className="text-xl font-medium text-black mb-1">
                {project.title}
              </h1>
  
              <div className="aspect-square flex relative mb-0 sm:mb-5">
                <img
                  alt="gallery"
                  className="absolute inset-0 w-full h-full object-cover object-center"
                  src={project.image}
                />
                <div id={`description-${i}`} className="px-5 py-5 relative z-1 hidden sm:inline opacity-0 hover:opacity-90 text-lg md:text-base sm:text-xs text-white bg-black">
                  <p className="leading-snug tracking-widest">{project.description}</p>
                  <div className="mt-2 flex">
                    { project.video && <a
                      id={`video-${i}`}
                      href={project.video}
                      target="_blank"
                      className="tracking-widest mr-2 inline-flex text-black bg-white border border-white border-white py-1 px-2 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-base md:text-base sm:text-xs">
                      Video
                    </a> }
                  
                    <a
                      id={`publication-${i}`}
                      href={project.publication}
                      target="_blank"
                      className="tracking-widest inline-flex text-white border py-1 px-2 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-base md:text-base sm:text-xs">
                      Publication
                    </a>
                  </div>
                </div>
              </div>
  
              <div id={`description-${i}`} className="mb-5 px-0 py-3 relative z-1 sm:hidden text-lg md:text-base sm:text-xs text-black">
                  <p className="leading-snug tracking-widest">{project.description}</p>
                  <div className="mt-2 flex">
                    { project.video && <a
                      id={`video-${i}`}
                      href={project.video}
                      target="_blank"
                      className="tracking-widest mr-2 inline-flex text-white bg-black border border-white py-1 px-2 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-base md:text-base sm:text-xs">
                      Video
                    </a> }
                  
                    <a
                      id={`publication-${i}`}
                      href={project.publication}
                      target="_blank"
                      className="tracking-widest inline-flex text-black border border-black py-1 px-2 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-base md:text-base sm:text-xs">
                      Publication
                    </a>
                  </div>
                </div>
  
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}


Projects.propTypes = {};

Projects.defaultProps = {};

export default Projects;

/*
               <div id={`description-${i}`} className="px-5 py-5 relative z-1 text-lg lg:text-lg md:text-sm sm:text-xs opacity-0 hover:opacity-90 bg-black">
                  <p className="leading-relaxed text-white">{project.description}</p>
                  <div className="mt-2 flex">
                    { project.video && <a
                      id={`video-${i}`}
                      href={project.video}
                      target="_blank"
                      className="mr-2 inline-flex text-black bg-white border border-white py-1 px-1 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-lg lg:text-lg md:text-sm sm:text-xs">
                      Video
                    </a> }
                  
                    <a
                      id={`publication-${i}`}
                      href={project.publication}
                      target="_blank"
                      className="inline-flex text-white border py-1 px-1 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-lg lg:text-lg md:text-sm sm:text-xs">
                      Publication
                    </a>
                  </div>
                </div>
                */


